/**
 * The default argument placeholder value for methods.
 *
 * @type {Object}
 */
module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/~/lodash/fp/placeholder.js
// module id = 51
// module chunks = 0